export default "__VITE_ASSET__4dbf5039__"